import styled from 'styled-components';

import { media } from 'utils/detection';

export default styled.div`
  position: relative;
  color: ${props => props.theme.secondary};
  font-family: ${props => props.theme.fontGalanoClassic};
  font-size: 48px;
  font-weight: 400;
  line-height: 40px;
  margin: 60px 0 50px 0;

  ${media.medium`
    margin: 0 0 50px 540px;
    display: none;
  `}
`;
